"use client";

import { TriangleAlert } from "lucide-react";

import { Button } from "@/components/ui/button";

interface CommandV2ExpiredConnectionsBannerProps {
    expiredNames: string[];
    onReconnect?: () => void;
    className?: string;
}

export function CommandV2ExpiredConnectionsBanner({
    expiredNames,
    onReconnect,
    className,
}: CommandV2ExpiredConnectionsBannerProps) {
    if (expiredNames.length === 0) return null;

    return (
        <div className={className}>
            <div className="rounded-xl border border-amber-300 bg-amber-50 px-3 py-2.5 dark:border-amber-700/50 dark:bg-amber-950/20 sm:px-4 sm:py-3">
                <p className="flex items-center gap-1.5 text-[13px] font-semibold text-amber-800 dark:text-amber-300">
                    <TriangleAlert className="size-3.5 shrink-0" />
                    Connection needs attention
                </p>
                <div className="mt-1.5 space-y-1.5">
                    {expiredNames.map((app) => (
                        <div
                            key={app}
                            className="flex items-center justify-between gap-3"
                        >
                            <p className="min-w-0 text-[13px] leading-snug text-amber-800/90 dark:text-amber-300/90">
                                <span className="font-medium">{app}</span> lost its connection —
                                re-authorise to keep this agent working.
                            </p>
                            {onReconnect ? (
                                <Button
                                    type="button"
                                    size="sm"
                                    className="h-7 shrink-0 rounded-full bg-amber-500 px-3 text-xs text-white hover:bg-amber-600"
                                    onClick={onReconnect}
                                >
                                    Reconnect
                                </Button>
                            ) : null}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
